import React, { useRef, useState } from "react";
import WmsModel from "../../components/WmsModel/WmsModel";
import WmsButton from "../../components/WmsButton/WmsButton";
import AuditInventoryReviewAuditJobGrid from "./audit-inventory-review-audit-job-grid.component";
import "./audit-inventory-review-audit-job-modal.scss";
import PropTypes from "prop-types";
import WmsConfirmModel from "../../components/WmsConfirmModel/WmsConfirmModel";
import { InventoryAuditReconcile } from "./review-audit-job.service";
import * as GlobalService from "../../global_services";
import * as auditInventoryServices from "../audit-inventory.services";

interface Props {
    wmsSelector: string;
    auditCountsUris: Array<string>;
    auditCountsEditUris: Array<string>;
    selectedRowData: any;
    isOpen: boolean;
    onReviewAuditJobModalClose: Function;
    getAuditOptions: Function;
    refreshGrid: Function;
    facilityUri: string;
    windowId: string;
}

declare var window: any;
const AuditInventoryReviewAuditJobModal: React.FC<Props> = (incomingProps: Props): any => {
    const {
        auditCountsUris = [],
        auditCountsEditUris = [],
        selectedRowData = [],
        isOpen = false,
        onReviewAuditJobModalClose = (): void => {},
        getAuditOptions = (): void => {},
        refreshGrid = (): void => {},
        windowId = "",
    } = incomingProps;
    const props = {
        ...incomingProps,
        auditCountsUris,
        auditCountsEditUris,
        selectedRowData,
        isOpen,
        onReviewAuditJobModalClose,
        getAuditOptions,
        refreshGrid,
        windowId,
    };

    const [isRconcileButtonDisabled, setIsReconcileButtonDisabled] = useState(true);
    const subGridSelectedData = useRef([]);
    const [isConfirmationModalShow, setIsConfirmationModalShow] = useState(false);
    const [isSelectedRowsHasTrackbys, setIsSelectedRowsHasTrackbys] = useState(false);
    const [isNotCountedRow, setIsNotCountedRow] = useState(false);
    const [isCloseJobAfterReconcile, setIsCloseJobAfterReconcile] = useState(false);
    const sendSubGridSelectedDataToModalComponent = (
        data: any,
        disableRecouncleButton = false,
        isAnyselectedRowsHasTrackbysRow = false,
        isNotCountedRow = false,
        closeJobAfterReconcile = false
    ) => {
        subGridSelectedData.current = data;
        const tempData = subGridSelectedData.current ? subGridSelectedData.current.length : 0;
        setIsReconcileButtonDisabled(
            tempData === 0 || (isAnyselectedRowsHasTrackbysRow && !props.selectedRowData[0].UseTrackBys)
        );
        setIsSelectedRowsHasTrackbys(isAnyselectedRowsHasTrackbysRow);
        setIsNotCountedRow(isNotCountedRow);
        setIsCloseJobAfterReconcile(closeJobAfterReconcile);
    };

    const onReconcileJobs = () => {
        setIsConfirmationModalShow(true);
    };

    const onCloseConfirmModal = () => {
        setIsConfirmationModalShow(false);
    };
    const onReconcileConfirm = () => {
        const param = {
            auditCountsUris: props.auditCountsUris,
            detailIds: subGridSelectedData.current,
        };
        InventoryAuditReconcile(param).then((response) => {
            if (isCloseJobAfterReconcile) {
                auditInventoryServices.closeJob(props.auditCountsEditUris);
                props.refreshGrid();
                GlobalService.notification("success", window.translate("Label_Close_job_success"));
            }
            GlobalService.notification("success", window.translate("Label_ConfirmReconciliation_Success"));
            onCloseConfirmModal();
            props.onReviewAuditJobModalClose();
        });
    };
    return (
        <div className={"audit-inventory-review-audit-job-modal"}>
            <WmsModel
                isOpen={props.isOpen}
                id={props.wmsSelector + "ReviewAuditJobModel"}
                title={window.translate("Review_Audit_Job_Model_title_Prefix") + " " + props.selectedRowData[0].Name}
                width={800}
                height={706}
                onCloseFunc={props.onReviewAuditJobModalClose}
                customClass={"wms-model-new-ui-wrapper"}
            >
                <div className={"model-content-wrapper"}>
                    <AuditInventoryReviewAuditJobGrid
                        windowId={props.windowId}
                        wmsSelector={props.wmsSelector}
                        auditCountsUris={props.auditCountsUris}
                        auditCountsEditUris={props.auditCountsEditUris}
                        reviewAuditJobTitle={props.selectedRowData[0].Name}
                        facilityUri={props.facilityUri}
                        mainGridSelectedRowData={props.selectedRowData[0]}
                        sendSubGridSelectedDataToModalComponent={sendSubGridSelectedDataToModalComponent}
                        onReviewAuditJobModalClose={props.onReviewAuditJobModalClose}
                        getAuditOptions={props.getAuditOptions}
                    />
                </div>
                <div className="footer-btn-holder">
                    <WmsButton
                        label={window.translate("Label_Reconcile_Selected")}
                        wmsSelector={"reviewAuditReconcileJobsButton"}
                        onClickFunc={onReconcileJobs}
                        disabled={isRconcileButtonDisabled}
                        loading={false}
                        buttonType="black"
                        showToolTip={isSelectedRowsHasTrackbys || isNotCountedRow}
                        tooltipText={
                            isSelectedRowsHasTrackbys
                                ? window.translate("Reconcile_Tooltip")
                                : window.translate("Label_Reconcile_Not_Counted_Tooltip")
                        }
                    />
                    <WmsButton
                        label={window.translate("Label_Close")}
                        wmsSelector={"reviewAuditCloseButton"}
                        onClickFunc={props.onReviewAuditJobModalClose}
                        disabled={false}
                        loading={false}
                        buttonType="orange"
                        icon={"fa-times-circle-o"}
                    />
                    <WmsConfirmModel
                        id={"AuditReviewReconciliation"}
                        isOpen={isConfirmationModalShow}
                        type={window.translate("Label_ConfirmReconciliation_Audit_Review_Job")}
                        width={500}
                        height={175}
                        firstBtnLabel={window.translate("Label_Select_Confirm")}
                        firstBtnIcon={"fa-check-square"}
                        firstBtnOnClickFunc={onReconcileConfirm}
                        onCloseFunc={onCloseConfirmModal}
                        sawCheckBox={false}
                        conFormModelText={window.translate(
                            "Label_ConfirmReconciliation_Audit_Review_Job_Modal_Content"
                        )}
                        thirdBtnLabel={window.translate("Label_Cancel")}
                        thirdBtnIcon={"fa-times-circle"}
                        closeModel={onCloseConfirmModal}
                    >
                        <div className="note">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: window.translate(
                                        "Label_ConfirmReconciliation_Audit_Review_Job_Modal_Content"
                                    ),
                                }}
                            ></div>
                            <div className="warning-text-wrapper">
                                <span className="warning-icon-text">
                                    <i className="fa fa-exclamation-triangle"></i> &nbsp;Warning!
                                </span>
                                &nbsp; The reconciliation process ignores inventory not assigned to a location. Before
                                reconciling
                                <br /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;inventory, make sure that all stock for the
                                item being reconciled has been assigned a valid location.
                            </div>
                        </div>
                    </WmsConfirmModel>
                </div>
            </WmsModel>
        </div>
    );
};

AuditInventoryReviewAuditJobModal.propTypes = {
    wmsSelector: PropTypes.string.isRequired,
    auditCountsUris: PropTypes.arrayOf(PropTypes.string),
    auditCountsEditUris: PropTypes.arrayOf(PropTypes.string),
    selectedRowData: PropTypes.any,
    isOpen: PropTypes.bool.isRequired,
    onReviewAuditJobModalClose: PropTypes.func,
    getAuditOptions: PropTypes.func,
    facilityUri: PropTypes.string.isRequired,
    windowId: PropTypes.string.isRequired,
};

export default React.memo(AuditInventoryReviewAuditJobModal);
